import { EventEmitter as EventEmitterInternal } from 'events';

export class EventEmitterX extends EventEmitterInternal {
    constructor() {
        super();
        this.events = {};
    }

    addListener(event, name, listener) {
        if (arguments.length === 3) {
            if (!this.events[name]) this.events[name] = {};
            this.events[name][event] = listener;
            super.addListener(event, listener);
            return () => super.removeListener(event, listener);
        }
        else {
            super.addListener(event, name);
            return () => super.removeListener(event, name);
        }
    }

    removeListenerByName(name) {
        if (!this.events[name]) return;
        for (const event in this.events[name]) {
            this.removeListener(event, this.events[name][event]);
            delete this.events[name][event];
        }
        return this;
    }
}